import TriptychItem, { TriptychItemModel } from './triptychItem'
import { useStyles } from "./styles";

interface TriptychProps {
  triptychList: TriptychItemModel[]
}

function Triptych({ triptychList }: TriptychProps) {
  const classes = useStyles();
  return (
    <div className={classes.triptychWrapper}>
      { triptychList.map((triptychItemData: TriptychItemModel, index: number) => <TriptychItem {...triptychItemData} key={index}/>) }
    </div>
  )
}

export default Triptych
